import { useNavigate } from "react-router-dom";

import {
  Button,
  Link as DSLink,
  DuotoneIcon,
  Heading,
  Span,
} from "@icg360/design-system";

import { Stack } from "components/common/stack";
import { useHideFeedbackTab, useHideSupportChat } from "utils";

import styles from "./shingle-reseal.module.scss";

export const Enrolled = () => {
  useHideSupportChat();
  useHideFeedbackTab();
  const navigate = useNavigate();
  return (
    <div className={styles.enrolledWrapper}>
      <div className={styles.enrolledContent}>
        <Stack className={styles.enrolledHeading}>
          <DuotoneIcon name="Done" size="lg" />
          <Heading size="lg">You&apos;re all set!</Heading>
        </Stack>
        <Span color="quiet" className={styles.enrolledSubHeading}>
          We&apos;ve sent you a confirmation email. If you have any questions or
          concerns, contact{" "}
          <DSLink href="mailto:support@liftlockhome.com">
            support@liftlockhome.com
          </DSLink>
          .
        </Span>
        <Heading size="sm">Here&apos;s what to expect:</Heading>
        <div className={styles.enrolledGrid}>
          <div className={styles.greyCircleIcon}>
            <Heading size="sm" className={styles.stepNumberDS}>
              1
            </Heading>
          </div>
          <Span medium className={styles.listText}>
            Hang tight while LiftLock monitors the weather
          </Span>

          <div className={styles.greyCircleIcon}>
            <Heading size="sm" className={styles.stepNumberDS}>
              2
            </Heading>
          </div>
          <Span medium className={styles.listText}>
            Get notified if selected
          </Span>

          <div className={styles.greyCircleIcon}>
            <Heading size="sm" className={styles.stepNumberDS}>
              3
            </Heading>
          </div>
          <div>
            <Span medium className={styles.listText}>
              Have roof prepared for strong winds
            </Span>
            <Span color="quiet" size="sm">
              A trained professional will clean gutters, clear roof debris, and
              secure loose shingles.
            </Span>
          </div>
        </div>
        <Span color="quiet" size="sm">
          Wind Defense is not available in all areas. Selection is dependent on
          service availability and other factors. There is no guarantee that you
          will receive the service by signing up.
        </Span>
        <div className={styles.confirmationButtons}>
          <Button
            onPress={() => navigate("/my/property")}
            data-testid="shingle-done"
          >
            Done
          </Button>
        </div>
      </div>
    </div>
  );
};
